module.exports = __webpack_public_path__ + "assets/63495d3864729f75a6370f394d81a0fe.svg";